import ParallaxBlock from './ParallaxBlock';

export { ParallaxBlockContainer, ParallaxBlockContainerMobile } from './ParallaxBlockContainer';
export { LinkButton, LinkButtonText, CustomLink, ArrowRight } from './ParallaxBlockContainer';
export { ParallaxBlockImage, ParallaxBlockImageMobile } from './ParallaxBlockImage';
export { ParallaxBlockContentItem, ParallaxBlockContentItemMobile } from './ParallaxBlockContentItem';
export { ParallaxBlockContent, ParallaxBlockContentMobile } from './ParallaxBlockContent';

export default ParallaxBlock;